import styled, {css} from 'styled-components'

export const StyledUserGroupsWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: auto auto minmax(0, 1fr);
        background-color: ${palette.neutral['white']};
        height: 100%;
        border-radius: 8px 8px 0 0;
        border: 1px solid ${palette.neutral[200]};
    `
)
